// extracted by mini-css-extract-plugin
export default {"container":"SybRp9","share-icons":"bPfLdB","shareIcons":"bPfLdB","share-icon":"awt1hV","shareIcon":"awt1hV"};